import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { showErrors } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import ProducerDialog from '@/modules/Producer/scripts/producer-dialog'
import ProducerDetailDetail from '@/modules/Producer/views/detail.vue'
import { getProducer } from '@/modules/Producer/gql/producer.gql'
import { dateTimeToDisplay, dateToNow } from '@/utils/dateTime'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    ProducerDetailDetail
  }
})
export default class ProducerDetail extends mixins(ProducerDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'Source',
      to: { name: 'ProducerList' }
    }
  ]

  formatPhoneNumber = formatPhoneNumber

  producer: Producer | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'ProducerDetailDetail'
    },
    {
      title: 'Quotes',
      route: 'ProducerDetailQuotes'
    },
    {
      title: 'Policies',
      route: 'ProducerDetailPolicy'
    },
    {
      title: 'Additional',
      route: 'ProducerDetailAdditional'
    }
  ]

  dateTimeToDisplay = dateTimeToDisplay
  dateToNow = dateToNow

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getProducer()
  }

  async getProducer () {
    const producerId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getProducer,
        variables: {
          producerId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.producer = result.data.getProducer as Producer
      if (this.breadcrumbs.length === 2) {
        this.breadcrumbs.push({
          text: this.producer.name
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route) {
      this.$router.push({
        name: item.route
      })
    }
  }
  async deleteProducerConfirm () {
    await this.deleteProducerPost()
    this.$router.replace({
      name: 'ProducerList'
    })
  }
}
